import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDImage, FDStack, FDTitleText } from '@facet-wealth/design';

export const ConnectionTitlePicker = (props) => {
  const { resource } = props;
  const icon = resource.withRelationship((fr.relationships.logo.name),
    (rel) => (
      <FDImage
        src={rel.link('related').url()}
        alt={'institution logo'}
        objectFit="contain"
        objectPosition="center"
        height="70px"
        width="70px"
      />),
    () => null);
  return (
    <FDStack direction="row" alignItems="center" spacing={2}>
      {icon}
      <FDTitleText value={resource.attr('title')} />
    </FDStack>
  );
};

ConnectionTitlePicker.defaultProps = {
};

ConnectionTitlePicker.propTypes = {
  resource: PropTypes.object.isRequired,
};
